<template>
  <div id="features" class="section">
    <div class="container">
      <article class="col s12">
        <h3 class="is-size-3">{{ $t("title") }}</h3>
        <hr class="line" />
      </article>
      <!-- <p class="has-text-justified">{{ $t("intro") }}</p>
      <br /> -->
      <section class="grid">
        <div
          class="grid-item hover-efx"
          v-for="(feature, i) in $t('features')"
          :key="i"
          data-aos="zoom-in"
          data-aos-delay="1"
          data-aos-duration="200"
        >
          <div class="has-text-centered">
            <div class="circle-container">
              <b class="circle-item is-size-2">{{ parseInt(i) + 1 }}</b>
            </div>
            <p class="is-size-4" style="height: 100px">
              {{ feature.title }}
            </p>
            <div class="has-text-centered">
              <img
                v-bind:src="getImgUrl(feature.icon)"
                :alt="feature.name"
                style="height: 150px"
              />
            </div>
            <br />
            <p>{{ feature.ctx }}</p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: "Features",
  data() {
    return {
      title: "Features",
    };
  },
  methods: {
    getImgUrl(pic) {
      return require("@/assets/features/" + pic + ".png");
    },
  },
};
</script>
<style scoped>
.circle-container {
  display: flex;
  justify-content: center;
}
.circle-item {
  padding: 0.5rem;
  border-radius: 0 0 100px 100px;
  border: solid 1px;
  width: 80px;
  background-color: #5a2c7e;
  color: #ffffff;
}
.grid {
  --grid-layout-gap: 5px;
  --grid-column-count: 4;
  --grid-item--min-width: 260px;
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}
.grid-item {
  background-color: #ffffff;
  padding: 0 1rem 2rem 1rem;
  border-radius: 20px;
  border: solid 1px #eaeaea;
  box-shadow: 1px 1px 1px #eaeaea;
}
.grid-item:hover {
  background-color: #ed404b;
  color: #ffffff !important;
}
</style>
<i18n>
{
  "es": {
    "title": "Características",
    "intro": "Porque aplicamos una metodología ágil entre equipos funcionales lo que nos permite implementar el proyecto en aproximadamente 4 meses enfocado en adaptarnos a los requerimientos del cliente y entregar un producto “llave en mano”. Ceptinel tiene su proceso dividido en las siguientes cuatro etapas",
    "features":[
      {
        "title":"Fácil de configurar, usar y gestionar",
        "icon":"settings",
        "ctx":"Lenguaje de programación visual \"no-code\" configurable por el cliente"
      },
      {
        "title":"Simple instalación y conexión",
        "icon":"ux",
        "ctx":"\"Plug and Play\" para datos internos y externos"
      },
      {
        "title":"Procesamiento en tiempo real",
        "icon":"data-analysis",
        "ctx":"Miles de datos por segundo"
      },
      {
        "title":"Mayor control y eficiencia",
        "icon":"data-transfer",
        "ctx":"Panel de reglas en la nube"
      }
    ]
  },
  "en": {
    "title": "Features",
    "intro": "Because we apply an agile methodology among functional teams, which allows us to implement the project in approximately 4 months, focused on adapting to the client's requirements and delivering a product “hand in hand”. Ceptinel has its process divided into the following four stages.",
    "features":[
      {
        "title":"Easy to set up, use and manage",
        "icon":"settings",
        "ctx":"Visual programming language \"no-code\" configurable by the client"
      },
      {
        "title":"Simple installation and connection",
        "icon":"ux",
        "ctx":"\"Plug and Play\" for internal and external data"
      },
      {
        "title":"Real-Time processing",
        "icon":"data-analysis",
        "ctx":"Thousands of data per second"
      },
      {
        "title":"Greater control and efficiency",
        "icon":"data-transfer",
        "ctx":"Cloud Rules Dashboard"
      }
    ]
  },
  "pt": {
    "title": "Caracteristicas",
    "intro": "Porque aplicamos uma metodologia ágil entre as equipas funcionais, o que nos permite implementar o projeto em cerca de 4 meses, focados na adaptação aos requisitos do cliente e na entrega de um produto “de mãos dadas”. A Ceptinel tem seu processo dividido nas quatro etapas a seguir.",
    "features":[
      {
        "title":"Fácil de configurar, usar e gerenciar",
        "icon":"settings",
        "ctx":"Linguagem de programação visual \"sem código\" configurável pelo cliente"
      },
      {
        "title":"Instalação e conexão simples",
        "icon":"ux",
        "ctx":"\"Plug and Play\" para dados internos e externos"
      },
      {
        "title":"Processamento em tempo real",
        "icon":"data-analysis",
        "ctx":"Milhares de dados por segundo"
      },
      {
        "title":"Maior controle e eficiência",
        "icon":"data-transfer",
        "ctx":"Painel de regras da nuvem"
      }
    ]
  }
}
</i18n>
